<template>
  <v-container fluid grid-list-md text-xs-center class="pt-0">
    <v-card class="pa-2 card-r shadow-1 grey lighten-4">
      <v-toolbar class="primary card-r pl-2 mb-3 text-white">
        <v-btn icon class="ma-0 primary text-white card-r no-shadow" to="/examstab#tests"> <v-icon>arrow_left</v-icon></v-btn>
        <div class="text-xs-left f-20 ml-3">Edit Exam</div>
      </v-toolbar>
    <v-layout row wrap>
      <v-flex xs4>
        <v-select
          solo
          :items="testTypes"
          item-text='text'
          item-value='value'
          class="input-group--focused"
          label="Exam Type"
          type="text"
          v-model="test.module_type"
        ></v-select>
      </v-flex>
      <v-flex xs4 class="pa-1">
                      <v-select
                        solo
                        :items="lang_type"
                        v-model="test.lang"
                        item-text='text'
                        item-value='value'
                        class="input-group--focused"
                        type="text"
                      ></v-select>
                    </v-flex>
      <v-flex xs4>
        <v-text-field v-if="test.test_type=='manual'" v-model="test.no_of_questions" readonly solo label="Number of questions"></v-text-field>
        <v-text-field v-if="test.test_type=='random'" v-model="test.no_of_questions" solo label="Number of questions"></v-text-field>
      </v-flex>
      
      <v-flex xs6>
        <v-text-field solo v-model="test.testName" label="Exam Name"></v-text-field>
      </v-flex>
      <v-flex xs3>
        <v-select
          solo
          v-model="test.selectedTime"
          :items="workMin"
          class="input-group--focused"
          label="Time"
          type="number"
        ></v-select>
      </v-flex>
      <v-flex xs3>
        <v-select
          solo
          :items="typs"
          readonly
          class="input-group--focused"
          label="Test Type"
          type="number"
          v-model="test.test_type"
        ></v-select>
      </v-flex>
     
      <v-flex xs8>
        <div  v-if="test.test_type=='manual'" class="pt-3 pb-2 justify f-15 font-weight-bold">Selected Questions </div>
      <!-- <div clas="left">Selected Questions:</div> -->
        <v-card class="left pt-3 pl-3 pr-3 f-12" v-for="(qu,index) in selectedQuestionsData">
            <div v-html="selectedQuestionsData[index].situation"></div>
        </v-card>
      </v-flex>

      <!-- <v-container fluid class="pa-0" v-if="test.test_type=='manual'">
          <v-layout row wrap>
            <v-flex xs12 class="pa-1">
              <manual @return-selected-questions="setSelectedQuestions"/>
            </v-flex>
          </v-layout>
      </v-container> -->

      <v-flex xs12 class="text-xs-right">
          <v-btn color="primary no-shadow right text-white" v-on:click='saveTest()' dark>Update Exam</v-btn>
          <!-- <v-btn color="primary no-shadow right text-white" @click="show=false" dark>Cancel</v-btn> -->
      </v-flex>
      <v-flex xs12 lg12 class="text-xs-center">
            <v-progress-circular
                indeterminate
                v-if=loading
                color="primary"
            ></v-progress-circular>
            <v-alert
              :value="true"
              color="success"
              icon="check_circle"
              v-if="alert.type=='success'"
              outline
            >
              {{alert.msg}}
            </v-alert>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              v-if="alert.type=='warning'"
              outline
            >
              {{alert.msg}}
              </v-alert>
        </v-flex>
    </v-layout>
    </v-card>
  </v-container>
</template>
<script>
  /*eslint-disable */

  import api from "@/utils/backend-api"
  import { mapState } from 'vuex'
  import router from "@/router"
  import Manual from './Manual'

  export default {
    props:['id'],
    data: () => ({
      loading:false,
      alert:{
        type:'',
        msg:''
      },
      show: false,
      workMin: [30, 45, 90, 135, 180, 225, 270],
      typs: ['random', 'manual'],
      types: [
        {text: 'Teori test', value: 'teori test'},
        {text: 'Kørsel test', value: 'kørsel test'},
        {text: 'Manøvre test', value: 'manøvre test'},
        {text: 'Glatbane test', value: 'glatbane test'},
        {text: 'Other test', value: 'other test'}
      ],
      testData:[],
      lang_type:['en','da'],
      testTypes:[],
      selectedType:'',
      test:{
        module_type:'',
        no_of_questions:'',
        testName:'',
        selectedTime:'',
        test_type:'',
        selectedQuestions:[]
      },
      selectedQuestions:'',
      selectedQuestionsData:''
    }),
    created:function(){

      api.postData('driver/viewTestCategory')
      .then(res=>{
        this.testTypes=res.data
        this.testTypes.push(nullType)
      })
      api.postData('driver/viewTest/'+this.id)
      .then(res=>{
        this.test.testName=res.data.name
        this.test.no_of_questions=res.data.question_count
        this.test.selectedTime=res.data.duration
        this.test.lang=res.data.lang
        this.test.module_type=res.data.module_type.length==0?'others':res.data.category
        this.test.test_type=res.data.test_type
        this.selectedQuestions=res.data.questions
        this.selectedQuestionsData=res.data.questions_data
      })
    },
    methods:{
        saveTest(){
            let self=this
            this.loading=true
            self.alert.type=""
            let Data={
              lang:'en',
              name:this.test.testName,
              category:this.test.module_type,
              lang:this.test.lang,
              test_type:this.test.test_type,
              duration:this.test.selectedTime,
              question_count:this.test.test_type=='random'?this.test.no_of_questions:this.selectedQuestionsData.length,
              questions:this.test.test_type=='random'?'':this.selectedQuestions,
              test_id:this.id
            }
            api.postData('driver/updateTest',Data)
            .then(res=>{
              self.loadTest()
              if(res.status==201){
                self.loading=false
                self.alert.type="success"
                self.alert.msg="Test successfully updated"
              }
              setTimeout(() => {
                router.push('/examstab#tests')
              }, 800);
            }).catch(err=>{
              self.loading=false
              self.alert.type="warning"
              self.alert.msg="Test creation failed"
            })
      },
      loadTest(){
        api.postData('driver/viewTest')
        .then(res=>{
            Store.dispatch('setTests', res.data)
            // self.testListsInfo=res.data
        })
      },
      setSelectedQuestions(selectedQuestions){
        this.selectedQuestions=selectedQuestions
      }
    },
    components: {
      Manual
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/pages/exams/EditTest.vue